export default __webpack_public_path__ + "static/media/H1007.4.1e96ef70.mp3";